(ns practitest.frontend.signup.events
  (:require
   [ajax.core :as ajax]
   [clojure.string :as str]
   [practitest.frontend.common.i18n :refer [get-translation default-locale]]
   [practitest.frontend.routing.backend-routes :as broutes]
   [practitest.frontend.signup.subs :as subs]
   [re-frame.core :as re-frame]))

(defn valid-password? [pw pattern]
  (re-matches (re-pattern pattern) pw))

(re-frame/reg-event-db
  ::update-field
  (fn [db [_ field value]]
    (assoc-in db [:signup field] value)))

(re-frame/reg-event-db
  ::toggle-field
  (fn [db [_ field]]
    (update-in db [:signup field] not)))

;; Shared by both the edit-signup and new-signup (registration) routes, which are never
;; mounted together. reset-code is only ever passed by the edit-signup route.
(re-frame/reg-event-db
  ::init
  (fn [db [_ reset-code]]
    (let [{:keys [email display_name cognito_sso time_zone locale time_zones locales
                  project_name hubspot_contact_id user_already_registered
                  signup_url_iframe authenticity_token]}
          (get-in db [:options :signup-data])]
      (assoc db :signup {:email                    email
                       :display-name             display_name
                       :cognito-sso?             cognito_sso
                       :time-zone                (or time_zone subs/default-time-zone)
                       :locale                   (or locale default-locale)
                       :time-zones               time_zones
                       :locales                  locales
                       :reset-code               reset-code
                       :project-name             project_name
                       :hubspot-contact-id       hubspot_contact_id
                       :user-already-registered? user_already_registered
                       :signup-url-iframe        signup_url_iframe
                       :authenticity-token       authenticity_token
                       :password                 ""
                       :show-password?           false
                       :terms-accepted?          false
                       :client-error             nil
                       :error                    nil
                       :loading?                 false}))))

(re-frame/reg-event-fx
  ::submit-signup
  (fn [{:keys [db]} _]
    (let [{:keys [cognito-sso? display-name time-zone locale password terms-accepted?]} (:signup db)
          reset-code (or (:reset-code (:signup db))
                         (get-in db [:current-route :path-params :code]))
          error (cond
                  (str/blank? display-name)
                  (get-translation "signup.error.name-required" "Name is required.")

                  (and (not cognito-sso?) (not (valid-password? password (get-in db [:options :password-complexity-pattern]))))
                  (get-translation "login.reset-password.password-hint"
                                   "8-40 chars · 1 uppercase · 1 lowercase · 1 digit · 1 special char")

                  (not terms-accepted?)
                  (get-translation "signup.error.terms-required" "You must accept the Terms of Service.")

                  :else nil)]
      (if error
        {:db (assoc-in db [:signup :error] error)}
        {:db (-> db
                 (assoc-in [:signup :loading?] true)
                 (assoc-in [:signup :error] nil))
         :http-xhrio {:method          :put
                      :uri             (broutes/get-url "signups#update" {:id reset-code})
                      :params          {:user {:display_name     display-name
                                               :password         password
                                               :time_zone        time-zone
                                               :locale           locale
                                               :terms_of_service (if terms-accepted? "1" "0")}}
                      :format          (ajax/json-request-format)
                      :response-format (ajax/json-response-format {:keywords? true})
                      :on-success      [::submit-signup-success]
                      :on-failure      [::submit-signup-failure]}}))))

(re-frame/reg-event-fx
  ::submit-signup-success
  (fn [{:keys [db]} [_ response]]
    (if (:success response)
      {:db       (assoc-in db [:signup :loading?] false)
       :navigate (:redirect_to response "/")}
      {:db (-> db
               (assoc-in [:signup :loading?] false)
               (assoc-in [:signup :error] (or (:error response) (get-translation "signup.error.generic" "Something went wrong, please try again"))))})))

(re-frame/reg-event-fx
  ::submit-signup-failure
  (fn [{:keys [db]} [_ {:keys [response]}]]
    {:db (-> db
             (assoc-in [:signup :loading?] false)
             (assoc-in [:signup :error] (or (:error response) (get-translation "signup.error.generic" "Something went wrong, please try again"))))}))
